var Model = require('../Model');

var CustomEquipment = Object.create(Model);

CustomEquipment.name = 'CustomEquipment';
CustomEquipment['@class'] = 'CustomEquipment';
CustomEquipment.url = 'customequipment';
CustomEquipment.fields = {
  equipmentClass: {
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    },
    default: null,
    section: 'Properties',
  },
  name: {
    type: 'text',
    default: '',
    validators: {
      length: {minimum: 1, maximum: 63, default: ''},
    },
    section: 'Properties',
  },
	location: {
    default: null,
    hidden: true
	},
  parentEquipment: {
    default: '',
    hidden: true
	},
  noChildrenDatasets: {
    default: false,
    hidden: true
  },
  showInSummary: {
    default: false,
    hidden: true
  },
  hideLabel: {
    default: false,
    section: 'Map'
  },
  mapPolygonColor: {
    type: 'text',
    default: '#2196F3',
    section: 'Map',
  },
  mapPolygonOpacity: {
    type: 'text',
    default: '0.9',
    section: 'Map',
  },
  mapPolygonWeight: {
    type: 'text',
    default: '1',
    section: 'Map',
  },
  mapPolygonFillColor: {
    type: 'text',
    default: '#2196F3',
    section: 'Map',
  },
  mapPolygonFillOpacity: {
    type: 'text',
    default: '0.9',
    section: 'Map',
  },
  mapSvg: {
    type: 'textarea',
    default: '',
    section: 'Map',
  },
  latitude: {
    type: 'text',
    default: '',
    section: 'Map',
  },
  longitude: {
    type: 'text',
    default: '',
    section: 'Map',
  },
  geojson: {
    type: 'textarea',
    default: '',
    section: 'Map',
  },
  hideInDiagram: {
    default: false,
    section: 'Diagram'
  },
  hideDiagram: {
    default: false,
    section: 'Diagram'
  },
  animationType: {
    type: 'select',
    default: 'none',
    options: [
      {name: 'None', value: 'none'},
      {name: 'Rotate', value: 'rotate'},
      {name: 'Damper', value: 'damper'},
      {name: 'Static SVG', value: 'staticSvg'},
    ],
    section: 'Diagram',
  },
  svg: {
    type: 'textarea',
    default: '',
    section: 'Diagram'
  },
  svgBackground: {
    type: 'textarea',
    default: '',
    section: 'Diagram'
  },
  svgForeground: {
    type: 'textarea',
    default: '',
    section: 'Diagram'
  },
  direction: {
    section: 'Diagram', 
    type: 'select',
    default: 'clockwise',
    options: [
      {name: 'Clockwise', value: 'clockwise'},
      {name: 'Counterclockwise', value: 'counterclockwise'},
    ]
  },
  rotatorDashArray: {
    type: 'text',
    default: '5, 5',
    section: 'Diagram',
  },
  rotatorColor: {
    type: 'text',
    default: '#2196F3',
    section: 'Diagram',
  },
  pointsLinked: {
    type: 'text',
    default: [],
    section: 'Diagram',
  },
  formula: {
    type: 'text',
    default: '',
    section: 'Diagram',
  },
  staticSvgs: {
    type: 'staticSvgList',
    default: [],
    section: 'Diagram',
  },
  minValue: {
    type: 'text',
    default: '',
    section: 'Diagram',
  },
  maxValue: {
    type: 'text',
    default: '',
    section: 'Diagram',
  }
};

module.exports = CustomEquipment;
